import { AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, inject, Injector, OnInit, signal, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonForm, CommonTextField, CommonTextFieldConfig, CommonTextFieldWidget, UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { FuncService } from '../../../../../../../services';


@Component({
	selector: 'cohort-meet-code-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonButtonRowWidget,
		CommonTextFieldWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './cohort-meet-code-editor.dialog.html'
})

export class CohortMeetCodeEditorDialog implements OnInit, AfterViewInit {

	public dialogRef = inject(MatDialogRef<CohortMeetCodeEditorDialog>);
	public dialogContext: DialogContext<{ accId: number, meetCode: string | undefined, isMeetCodeGenerated: boolean }> = inject(MAT_DIALOG_DATA);

	private readonly util = inject(UtilityService);
	private func = inject(FuncService);

	public readonly form = new CommonForm<{ meetCode: string }>(inject(Injector));
	public saveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('saveBtn');

	public header = 'Add Cohort Google Meet Code';

	ngOnInit() {
		if (this.dialogContext.data?.meetCode) {
			this.header = 'Edit Cohort Google Meet Code';
		}
	}


	ngAfterViewInit() {
		this.form.setSubmitButton(this.saveBtn(), async (values: { meetCode: string }, changed: string[]) => {

			if (changed.length === 0) return;

			const dialogContextData = this.dialogContext.data;
			if (!dialogContextData) return;

			await this.func.accelerator.updateGoogleMeetCode({
				accId: dialogContextData.accId,
				googleMeetCode: this.util.url.extractMeetCode(values.meetCode)
			});

			await this.dialogRef.close();
		});
	}



	//
	// Form Fields
	//
	readonly meetCode = computed<CommonTextField>(() => ({
		config: signal<CommonTextFieldConfig>({
			label: 'Cohort Google Meet Code',
			isRequired: false,
			min: 0,
			max: 60,
			fixCase: 'none',
			multiLine: false,
		}),
		formFieldName: 'meetCode',
		form: this.form,
		actualValue: computed(() => this.dialogContext.data?.meetCode ?? ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));
}